export default "__VITE_ASSET__Co66E16K__"